import { ViewModel,View } from "binder"
import { ExecutableViewModel } from "../executable/executable-viewModel";
import { JsCodeViewModel } from "../executablePart/jsCode/jsCode-viewModel";
import  { MethodBodyManipulatorView } from "./methodBodyManipulator-view"

export class MethodBodyManipulatorViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.executable = new ExecutableViewModel(this);
        this.executable.addExecutablePart(new JsCodeViewModel(this));
    }
    GetDefaultView(): View <ViewModel> {
        return new MethodBodyManipulatorView();
    }
    public getTypeId(): string {
        return "VM-4DD23823-1016-4E5E-940D-1ABB3C567B2C"
    }

    public set executable(v: ExecutableViewModel) { this._executable = v; } public get executable(): ExecutableViewModel { return this._executable;} private _executable: ExecutableViewModel;


    serialize():any{
        return this.executable.serialize();
    }
    deserialize(code:any){
        this.executable.deserialize(code);
    }
}
